import * as Yup from 'yup';

const numberRequired = () => Yup.number().required('Pole jest wymagane');

export default Yup.object().shape({
  distanceFrom: numberRequired(),
  distanceTo: numberRequired().moreThan(Yup.ref('distanceFrom'), "Dystans 'Do' musi być większy niż 'Od'"),
  price: numberRequired().min(0, 'Cena nie może być mniejsza od 0'),
});
